import React, { useEffect, useState } from "react";
import { Modal, Row, Col, notification, Button, Skeleton } from "antd";
import moment from "moment";
import axios from "axios";

import { TIPOS_PLANO } from "../../Planos/planos.constants";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const ModalPlanoAtendimento = ({ id, visible, onCancel, onDelete }) => {
    const [plano, setPlano] = useState({
        tipo: "",
        data_realizacao: moment(),
        nome: "",
        idade: null,
        ano_serie: "",
        turno: "",
        escola: "",
        professor_aee: "",
        historico_escolas: "",
        necessidades_educacionais: "",
        objetivos_cognitivos: "",
        objetivos_socioemocionais: "",
        estrategias_recursos: "",
        parcerias: "",
        cronograma_atendimentos: "",
        avaliacao_monitoramento: "",
        descricao: "",
        tecnicas_utilizadas: ""
    });
    const [isLoading, setIsLoading] = useState(false);

    const carregarDetalhe = id => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/atendimento/carregar-plano-atendimento",
            params: {
                id
            }
        })
            .then(response => {
                setPlano(response.data);
            })
            .catch(error => {
                openNotificationWithIcon(
                    "error",
                    "Erro",
                    error.response.data || "Ocorreu um erro ao carregar o detalhe do plano de atendimento."
                );
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const validarExcluirPlano = () => {
        confirm({
            title: "Pretende remover este plano de atendimento?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                excluirPlano();
            }
        });
    };

    const excluirPlano = () => {
        axios({
            method: "put",
            url: "/api/atendimento/excluir-plano-atendimento",
            params: {
                id
            }
        })
            .then(() => {
                openNotificationWithIcon("success", "Plano removido", "O registro foi removido com sucesso.");
                onDelete();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao excluir o plano de atendimento.");
            });
    };

    useEffect(() => {
        if (id && visible) carregarDetalhe(id);
    }, [id]);

    return (
        <Modal
            title="Plano de Atendimento Especializado"
            className="modal-detalhe-info"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancelar" onClick={onCancel}>
                    Cancelar
                </Button>,
                <Button key="eliminar" className="modal-detalhe-info-delete-btn" type="danger" onClick={validarExcluirPlano}>
                    Excluir Plano
                </Button>
            ]}
            centered
            width={800}
            bodyStyle={{
                maxHeight: "60vh",
                overflowY: "auto"
            }}
        >
            <div className="modal-detalhe-info__body">
                <div className="modal-detalhe-info__section">
                    <Row gutter={16} style={{ marginBottom: 16 }}>
                        <Col span={12}>
                            <span className="field-label">Tipo</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{TIPOS_PLANO[plano.tipo]}</p>
                            </Skeleton>
                        </Col>
                        <Col span={12}>
                            <span className="field-label">Data de Realização</span>
                            <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                <p className="field-value">{moment(plano.data).format("DD/MM/YYYY")}</p>
                            </Skeleton>
                        </Col>
                    </Row>
                </div>
                {plano.tipo === "plano_atendimento_especializado" && (
                    <>
                        <div className="modal-detalhe-info__section">
                            <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                                1. Identificação do Estudante
                            </h3>

                            <Row gutter={16}>
                                <Col span={12}>
                                    <span className="field-label">Nome</span>
                                    <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                        <p className="field-value">{plano.nome}</p>
                                    </Skeleton>
                                </Col>
                                <Col span={12}>
                                    <span className="field-label">Idade</span>
                                    <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                        <p className="field-value">{plano.idade || "-"}</p>
                                    </Skeleton>
                                </Col>

                                <Col span={12}>
                                    <span className="field-label">Ano/Série</span>
                                    <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                        <p className="field-value">{plano.ano_serie || "-"}</p>
                                    </Skeleton>
                                </Col>
                                <Col span={12}>
                                    <span className="field-label">Turno</span>
                                    <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                        <p className="field-value">{plano.turno || "-"}</p>
                                    </Skeleton>
                                </Col>

                                <Col span={12}>
                                    <span className="field-label">Escola</span>
                                    <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                        <p className="field-value">{plano.escola || "-"}</p>
                                    </Skeleton>
                                </Col>
                                <Col span={12}>
                                    <span className="field-label">Professor AEE</span>
                                    <Skeleton loading={isLoading} paragraph={false} active width={30} className="field-skeleton">
                                        <p className="field-value">{plano.professor_aee || "-"}</p>
                                    </Skeleton>
                                </Col>
                            </Row>
                        </div>
                        <div className="modal-detalhe-info__section">
                            <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                                2. Histórico Escolar e Funcional
                            </h3>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                        <p className="field-value--wide">{plano.historico_escolas || "-"}</p>
                                    </Skeleton>
                                </Col>
                            </Row>
                        </div>
                        <div className="modal-detalhe-info__section">
                            <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                                3. Caracterização e Necessidades Educacionais Específicas
                            </h3>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                        <p className="field-value--wide">{plano.necessidades_educacionais || "-"}</p>
                                    </Skeleton>
                                </Col>
                            </Row>
                        </div>
                        <div className="modal-detalhe-info__section">
                            <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                                4. Objetivos do AEE
                            </h3>

                            <h4 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                                Cognitivos:
                            </h4>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                        <p className="field-value--wide">{plano.objetivos_cognitivos || "-"}</p>
                                    </Skeleton>
                                </Col>
                            </Row>
                            <h4 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                                Socioemocionais e Comportamentais:
                            </h4>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                        <p className="field-value--wide">{plano.objetivos_socioemocionais || "-"}</p>
                                    </Skeleton>
                                </Col>
                            </Row>
                        </div>
                        <div className="modal-detalhe-info__section">
                            <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                                5. Estratégias Pedagógicas e Recursos
                            </h3>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                        <p className="field-value--wide">{plano.estrategias_recursos || "-"}</p>
                                    </Skeleton>
                                </Col>
                            </Row>
                        </div>
                        <div className="modal-detalhe-info__section">
                            <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                                6. Parcerias
                            </h3>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                        <p className="field-value--wide">{plano.parcerias || "-"}</p>
                                    </Skeleton>
                                </Col>
                            </Row>
                        </div>
                        <div className="modal-detalhe-info__section">
                            <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                                7. Cronograma de Atendimentos
                            </h3>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                        <p className="field-value--wide">{plano.cronograma_atendimentos || "-"}</p>
                                    </Skeleton>
                                </Col>
                            </Row>
                        </div>
                        <div className="modal-detalhe-info__section">
                            <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                                8. Avaliação e Monitoramento
                            </h3>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                        <p className="field-value--wide">{plano.avaliacao_monitoramento || "-"}</p>
                                    </Skeleton>
                                </Col>
                            </Row>
                        </div>
                    </>
                )}
                {plano.tipo === "estudo_caso_diagnostico" && (
                    <>
                        <div className="modal-detalhe-info__section">
                            <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                                Descrição
                            </h3>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                        <p className="field-value--wide">{plano.descricao || "-"}</p>
                                    </Skeleton>
                                </Col>
                            </Row>
                        </div>
                        <div className="modal-detalhe-info__section">
                            <h3 style={{ marginTop: 16 }} className="modal-detalhe-info__section-title">
                                Técnicas Utilizadas
                            </h3>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Skeleton loading={isLoading} title={false} active width={30} className="field-skeleton">
                                        <p className="field-value--wide">{plano.tecnicas_utilizadas || "-"}</p>
                                    </Skeleton>
                                </Col>
                            </Row>
                        </div>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default ModalPlanoAtendimento;
